<template>
  <div>
    <!-- {{filterDatas}} -->
    <v-text-field
      label="Search"
      outlined
      dense
      hide-details="auto"
      v-model="filterDatas.search"
      clearable
      @input="onChange(filterDatas.search)"
    ></v-text-field>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Speech2Text from '../../components/base/SpeechToText/SpeechToText';

export default {
  name: 'date',
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    search: null,
  }),
  computed: {
    ...mapState(['filterDatas']),
  },
  components: {
    Speech2Text,
  },
  methods: {
    onChange(data) {
      if (this.filterDatas.isrouteNewPage == false) {
        this.$store.commit('UPDATE_SEARCH_FILTER_SIZE', data);
        this.$emit('input', this.filterDatas.search);
      } else {
        this.$emit('input', data);
      }
    },
  },
  mounted() {
    if (this.filterDatas.isrouteNewPage == false) {
      this.search = this.filterDatas.search;
      this.$emit('input', this.filterDatas.search);
    }
  },

  watch: {
    clear: {
      handler(val) {
        this.filterDatas.search = null;
      },
      deep: true,
    },
  },
};
</script>
